var map = {
	"./bialystok/index/section-3_pl.mdx": [
		50237,
		50237
	],
	"./bydgoszcz/index/section-3_pl.mdx": [
		98634,
		98634
	],
	"./czestochowa/index/section-3_pl.mdx": [
		96995,
		96995
	],
	"./garwolin/index/section-3_pl.mdx": [
		40272,
		40272
	],
	"./gdansk/index/section-3_pl.mdx": [
		7757,
		7757
	],
	"./gdynia/index/section-3_pl.mdx": [
		38861,
		38861
	],
	"./gliwice/index/section-3_pl.mdx": [
		98629,
		98629
	],
	"./gmina-swidnica/index/section-3_pl.mdx": [
		45828,
		45828
	],
	"./kielce/index/section-3_pl.mdx": [
		15366,
		15366
	],
	"./kolobrzeg/index/section-3_pl.mdx": [
		88008,
		88008
	],
	"./konskowola/index/section-3_pl.mdx": [
		16605,
		16605
	],
	"./koszalin/index/section-3_pl.mdx": [
		96270,
		96270
	],
	"./lask/index/section-3_pl.mdx": [
		45746,
		45746
	],
	"./lodz/index/section-3_pl.mdx": [
		90292,
		90292
	],
	"./lublin/index/section-3_pl.mdx": [
		67869,
		67869
	],
	"./miejsce-piastowe/index/section-3_pl.mdx": [
		57128,
		57128
	],
	"./mikolow/index/section-3_pl.mdx": [
		98125,
		98125
	],
	"./naklo/index/section-3_pl.mdx": [
		45168,
		45168
	],
	"./oborniki/index/section-3_pl.mdx": [
		21582,
		21582
	],
	"./olesnica/index/section-3_pl.mdx": [
		46981,
		46981
	],
	"./postomino/index/section-3_pl.mdx": [
		28889,
		28889
	],
	"./poznan/index/section-3_pl.mdx": [
		26177,
		26177
	],
	"./przechlewo/index/section-3_pl.mdx": [
		77390,
		77390
	],
	"./radom/index/section-3_pl.mdx": [
		21936,
		21936
	],
	"./raszkow/index/section-3_pl.mdx": [
		56516,
		56516
	],
	"./rawicz/index/section-3_pl.mdx": [
		74671,
		74671
	],
	"./ryman/index/section-3_pl.mdx": [
		16956,
		16956
	],
	"./sierakowice/index/section-3_pl.mdx": [
		9635,
		9635
	],
	"./slawno/index/section-3_pl.mdx": [
		33883,
		33883
	],
	"./slawoborze/index/section-3_pl.mdx": [
		39937,
		39937
	],
	"./stare-babice/index/section-3_pl.mdx": [
		59921,
		59921
	],
	"./szczecin/index/section-3_pl.mdx": [
		72932,
		72932
	],
	"./szemud/index/section-3_pl.mdx": [
		87273,
		87273
	],
	"./warszawa/index/section-3_pl.mdx": [
		53677,
		53677
	],
	"./wloszczowa/index/section-3_pl.mdx": [
		67402,
		67402
	],
	"./wroclaw/index/section-3_pl.mdx": [
		99114,
		99114
	],
	"./wyszkow/index/section-3_pl.mdx": [
		65975,
		65975
	],
	"./zukowo/index/section-3_pl.mdx": [
		89950,
		89950
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 52672;
module.exports = webpackAsyncContext;